export * from './svg-viewer.component';
export * from './svg-viewer.module';
